// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__1RaXd","body":"styles_body__1fwro"};